import React from 'react'
import { createRoot } from 'react-dom/client'

import '~/i18n/index'
import ErrorBoundary from '~/components/ErrorBoundary'

import './assets/scss/newtail.scss'
import App from './app'

window.React = React

const renderApp = () => {
  const container = document.getElementById('root')
  if (!container) {
    throw new Error('Failed to find the root element (#root) to mount the app')
  }
  const root = createRoot(container)
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  )
}

renderApp()
